import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import styles from '../pa_chamados_sourcing.module.scss';
import { useChamadosSourcingContext } from '../pa_chamados_sourcing_context';
import { useState } from 'react';
import { formatarCNPJ, formatarTelefone } from '../../../../utils/misc_utils';
import { listaBool } from './pa_chamados_sourcing_options';
import Select from 'react-select';
import { api } from '../../../../services/api';
import { useMisc } from '../../../../contexts/MiscContext';
import { toast } from 'react-toastify';
import { toBrDateWithTime } from '../../../../utils/dateUtils';
import CookiesService from '../../../../services/cookies';

const ChamadoQualidadePA = () => {
  const { setShowLoading } = useMisc();
  const {
    dadosChamadoAtivo,
    listaDefeitosMedidas,
    listaDefeitosAcabamento,
    listaDefeitosCostura,
    showDetalhes,
    fecharModalDetalhes,
    abrirDetalhesChamado,
    carregarChamados
  } = useChamadosSourcingContext();
  const [showModalConfirmacao, setShowModalConfirmacao] = useState(false);
  const [showModalCancelamento, setShowModalCancelamento] = useState(false);
  const [userId] = useState(CookiesService.getUserId());

  const chamado = dadosChamadoAtivo || {};

  const [formulario, setFormulario] = useState({
    amostra_possui_defeitos: null,
    pontuacao_total_defeitos: 0,
    defeitos: [],
    observacoes_cq_pa: null,
    laudo: null
  });

  const toggleDefeito = (id_defeito, pontos) => {
    const jaSelecionado = formulario.defeitos.includes(id_defeito);
    const novaPontuacao = jaSelecionado
      ? formulario.pontuacao_total_defeitos - pontos
      : formulario.pontuacao_total_defeitos + pontos;

    const novosDefeitos = jaSelecionado
      ? formulario.defeitos.filter(id => id !== id_defeito)
      : [...formulario.defeitos, id_defeito];

    setFormulario(prev => ({
      ...prev,
      defeitos: novosDefeitos,
      pontuacao_total_defeitos: novaPontuacao
    }));
  }

  const renderCheckboxGrupo = (lista, grupo) => (
    <div className={styles.defeito_wrapper}>
      <h6>{grupo}</h6>
      <div className={styles.defeito_box}>
        {lista.map(defeito => (
          <Form.Check
            key={defeito.id_defeito}
            id={`def_${defeito.id_defeito}`}
            type="checkbox"
            label={`${defeito.descricao} - ${defeito.pontos} ponto${defeito.pontos > 1 ? 's' : ''}`}
            disabled={!formulario.amostra_possui_defeitos?.value}
            checked={formulario.defeitos.includes(defeito.id_defeito)}
            onChange={() => toggleDefeito(defeito.id_defeito, defeito.pontos)}
            className="mb-2"
          />
        ))}
      </div>
    </div>
  );

  const customSelectStyles = {
    control: provided => ({
      ...provided,
      minHeight: '32px',
      height: '32px',
      maxHeight: '32px',
      border: '1px solid #dee2e6',
      boxShadow: 'none',
      lineHeight: '1.5'
    }),
    valueContainer: provided => ({
      ...provided,
      height: '32px',
      padding: '0 6px',
      lineHeight: '1.5'
    }),
    input: provided => ({
      ...provided,
      margin: '0px',
      padding: '0px',
      lineHeight: '1.5'
    }),
    indicatorsContainer: provided => ({
      ...provided,
      height: '32px',
      lineHeight: '1.5'
    }),
  }

  const confirmarRecebimentoAmostra = async () => {
    try {
      setShowLoading(true);
      const res = await api.post('pa/chamados-sourcing/atualizar-amostra-recebida', { id_chamado: chamado.id_chamado });
      if (res.data.chamado_cancelado) {
        toast.warn(`Não foi possível confirmar o recebimento, pois o chamado ${chamado.id_chamado} foi cancelado.`);
      }

      await abrirDetalhesChamado({ id_chamado: chamado.id_chamado, referencia_produto: chamado.referencia_produto });
      setShowModalConfirmacao(false);
      await carregarChamados(true);
      toast.success('Recebimento da amostra confirmado.');
    } catch (e) {
      toast.error('Ocorreu um problema ao processar a atualização do chamado. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const keyToErr = {
    amostra_possui_defeitos: 'Campo Amostra Possui Defeitos inválido',
    defeitos: 'Insira pelo menos um defeito ou indique que a amostra não possui defeitos',
    laudo: 'Insira um laudo'
  }

  const validarFormulario = () => {
    const errs = [];
    const { amostra_possui_defeitos, defeitos, laudo } = formulario;

    if (amostra_possui_defeitos === null) errs.push('amostra_possui_defeitos');
    if (amostra_possui_defeitos?.value && defeitos.length === 0) errs.push('defeitos');
    if (!laudo) errs.push('laudo');

    return errs;
  }

  const cancelarChamado = async () => {
    try {
      setShowLoading(true);
      const params = { id_chamado: chamado.id_chamado, id_usuario: userId }
      const res = await api.post('pa/chamados-sourcing/cancelar-chamado', params);
      if (res.data.chamado_cancelado) {
        toast.warn(`Desculpe, parece que o chamado ${chamado.id_chamado} já foi cancelado.`);
      }

      await abrirDetalhesChamado({ id_chamado: chamado.id_chamado, referencia_produto: chamado.referencia_produto });
      setShowModalCancelamento(false);
      await carregarChamados(true);
      toast.success('Chamado cancelado com sucesso.');
    } catch (e) {
      toast.error('Ocorreu um problema ao processar o cancelamento do chamado. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const finalizarChamado = async () => {
    try {
      setShowLoading(true);
      const errs = validarFormulario();
      if (errs.length > 0) {
        return toast.warning(
          <div>
            Por favor faça as seguintes correções:
            {errs.map((err, i) => (
              <div key={`err_${i}`}>{keyToErr[err]}</div>
            ))}
          </div>
        );
      }

      const formData = new FormData();
      const { laudo, ...rest } = formulario;

      formData.append('params', JSON.stringify({
        id_chamado: chamado.id_chamado,
        ...rest,
      }));

      if (laudo) formData.append('laudo', laudo);
      const res = await api.post('pa/chamados-sourcing/finalizar-chamado', formData);
      if (res.data.chamado_cancelado) {
        toast.warn(`Não foi possível finalizar pois o chamado ${chamado.id_chamado} foi cancelado.`);
      }

      await abrirDetalhesChamado({ id_chamado: chamado.id_chamado, referencia_produto: chamado.referencia_produto });
      await carregarChamados(true);
    } catch (e) {
      toast.error('Ocorreu um problema ao processar a finalização do chamado. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const calcColor = () => {
    if (chamado.amostra_recebida && chamado.finalizado) {
      return chamado.pontuacao_total_defeitos <= 1
        ? 'green'
        : chamado.pontuacao_total_defeitos <= 5
          ? 'gold'
          : 'tomato';
    }
    return formulario.pontuacao_total_defeitos <= 1
      ? 'green'
      : formulario.pontuacao_total_defeitos <= 5
        ? 'gold'
        : 'tomato';
  }

  return (
    <>
      <Modal
        show={showDetalhes}
        onHide={fecharModalDetalhes}
        size="xl"
        backdrop="static"
        fullscreen="lg-down"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Chamado #{chamado.id_chamado}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: '20px' }}>
          <Row className="mb-3">
            <Col md={12}>
              <label>Tipo |</label>
              <span className={styles.prod_value}>Sourcing - Qualidade PA</span>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={12}>
              <label>Categoria do Chamado |</label>
              <span className={styles.prod_value}>Solicitação de Análise Qualidade PA - {chamado.tipo_chamado}</span>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={12}>
              <label>Situação |</label>
              <span className={styles.prod_value}>
                {!chamado.finalizado && !chamado.cancelado && 'Aguardando análise CQ PA'}
                {chamado.finalizado && 'Chamado finalizado'}
                {
                  chamado.cancelado &&
                  <span style={{ color: 'red' }}>
                    Chamado cancelado em {toBrDateWithTime(chamado.data_cancelamento)}
                  </span>
                }
              </span>
            </Col>
          </Row>

          <hr />

          <h6>DADOS DO CONTATO</h6>
          <Row className="mb-3">
            <Col md={4}>
              <label>Nome do Contato |</label>
              <span className={styles.prod_value}>{chamado.nome_contato || '-'}</span>
            </Col>
            <Col md={4}>
              <label>Email |</label>
              <span className={styles.prod_value}>{chamado.email_contato || '-'}</span>
            </Col>
            <Col md={4}>
              <label>Telefone |</label>
              <span className={styles.prod_value}>{formatarTelefone(chamado.telefone_contato) || '-'}</span>
            </Col>
          </Row>

          <hr />

          <h6>DADOS DO FORNECEDOR</h6>
          <Row className="mb-3">
            <Col md={4}>
              <label>Nome Fantasia |</label>
              <span className={styles.prod_value}>{chamado.nome_fantasia_fornecedor || '-'}</span>
            </Col>
            <Col md={4}>
              <label>CNPJ |</label>
              <span className={styles.prod_value}>{formatarCNPJ(chamado.cnpj_fornecedor) || '-'}</span>
            </Col>
            <Col md={4}>
              <label>Tipo Fornecedor |</label>
              <span className={styles.prod_value}>{chamado.tipo_fornecedor || '-'}</span>
            </Col>
          </Row>

           {chamado.tipo_chamado === 'Fornecedor Atual Desenvolvimento' &&
            <Row className="mb-3">
              <Col md={4}>
                <label>Nome Fantasia Principal |</label>
                <span className={styles.prod_value}>{chamado.nome_fantasia_fornecedor_principal || '-'}</span>
              </Col>
              <Col md={4}>
                <label>CNPJ Principal |</label>
                <span className={styles.prod_value}>{formatarCNPJ(chamado.cnpj_fornecedor_principal) || '-'}</span>
              </Col>
            </Row>
          }

          <Row className="mb-3">
            <Col md={4}>
              <label>Possui Corte |</label>
              <span className={styles.prod_value}>{chamado.possui_corte ? 'SIM' : 'NÃO'}</span>
            </Col>
            <Col md={4}>
              <label>Capacidade Produtiva |</label>
              <span className={styles.prod_value}>{chamado.capacidade_total_produtiva || '-'}</span>
            </Col>
            <Col md={4}>
              <label>UF |</label>
              <span className={styles.prod_value}>{chamado.uf || '-'}</span>
            </Col>
          </Row>

          <hr />

          <h6>DADOS DE ENVIO DE AMOSTRA</h6>
          <Row className="mb-3">
            <Col md={4}>
              <label>Responsável Sourcing |</label>
              <span className={styles.prod_value}>{chamado.responsavel_sourcing || '-'}</span>
            </Col>
            <Col md={4}>
              <label>Email Responsável Sourcing |</label>
              <span className={styles.prod_value}>{chamado.email_responsavel_sourcing || '-'}</span>
            </Col>
            <Col md={4}>
              <label>Tipo de Produto |</label>
              <span className={styles.prod_value}>{chamado.tipo_produto || '-'}</span>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <label>Lacre Envio |</label>
              <span className={styles.prod_value}>{chamado.numero_lacre_envio || '-'}</span>
            </Col>
            <Col md={4}>
              <label>Referência do Produto |</label>
              <span className={styles.prod_value}>{chamado.referencia_produto || '-'}</span>
            </Col>
            <Col md={4}>
              <label>Piloto Enviada? |</label>
              <span className={styles.prod_value}>{chamado.piloto_enviada ? 'SIM' : 'NÃO'}</span>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <label>Ficha Técnica Enviada? |</label>
              <span className={styles.prod_value}>{chamado.ficha_tecnica_enviada ? 'SIM' : 'NÃO'}</span>
            </Col>
          </Row>

          <hr />

          <h6>DADOS DO PRODUTO</h6>
          <Row className="mb-3">
            <Col md={6}>
              <label>Marca |</label>
              <span className={styles.prod_value}>{chamado.marca || '-'}</span>
            </Col>
            <Col md={6}>
              <label>Descrição do Produto |</label>
              <span className={styles.prod_value}>{chamado.desc_produto || '-'}</span>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <label>Linha |</label>
              <span className={styles.prod_value}>{chamado.linha || '-'}</span>
            </Col>
            <Col md={6}>
              <label>Grupo |</label>
              <span className={styles.prod_value}>{chamado.grupo_produto || '-'}</span>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <label>Composição |</label>
              <span className={styles.prod_value}>{chamado.desc_composicao || '-'}</span>
            </Col>
            <Col md={6}>
              <label>Status do Produto (Lacre) |</label>
              <span className={styles.prod_value}>{chamado.status_lacre_atual || '-'}</span>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <label>Última Movimentação Linx |</label>
              <span className={styles.prod_value}>{toBrDateWithTime(chamado.data_movimentacao) || '-'}</span>
            </Col>
            <Col md={6}>
              <label>Data Piloto Lacrada Linx |</label>
              <span className={styles.prod_value}>{toBrDateWithTime(chamado.data_aprovacao) || '-'}</span>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <label>Estoque Atual PLM |</label>
              <span className={styles.prod_value}>{chamado.estoque_destino || '-'}</span>
            </Col>
            <Col md={6}>
              <label>Localização PLM |</label>
              <span className={styles.prod_value}>{chamado.localizacao || '-'}</span>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <label>Data Piloto PLM |</label>
              <span className={styles.prod_value}>{toBrDateWithTime(chamado.data_piloto_plm) || '-'}</span>
            </Col>
            <Col md={6}>
              <label>Grau de Dificuldade da Peça |</label>
              <span className={styles.prod_value}>{chamado.grau_dif_pos_provao || '-'}</span>
            </Col>
          </Row>

          <hr />

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Nicho de Atuação</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={chamado.nicho_atuacao || 'Nicho de atuação não informado.'}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Maquinários Específicos</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={chamado.maquinarios || 'Maquinários específicos não informados.'}
                  readOnly
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Restrições</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={chamado.restricoes || 'Nenhuma restrição informada.'}
                  readOnly
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Observações</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={chamado.observacoes || 'Nenhuma observação foi inserida.'}
                  readOnly
                />
              </Form.Group>
            </Col>
          </Row>

          <hr />

          <h6>DADOS GERAIS CQ PA</h6>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Label>Amostra Recebida?</Form.Label>
              {
                chamado.amostra_recebida &&
                <div className={styles.important_data} style={{ color: '#0D6EFDDD' }}>
                  Sim | {toBrDateWithTime(chamado.amostra_recebida_em)}
                </div>
              }
              {
                !chamado.amostra_recebida &&
                <Button
                  style={{ fontWeight: '500', width: '200px' }}
                  variant="success"
                  onClick={() => setShowModalConfirmacao(true)}
                >
                  Confirmar Recebimento
                </Button>
              }
            </Col>

            <div className={styles.vertical_separator} />

            <Col md={2}>
              <Form.Label>Amostra Possui Defeitos?</Form.Label>
              {
                !chamado.finalizado &&
                <Select
                  styles={customSelectStyles}
                  value={formulario.tipo_amostra}
                  onChange={e => setFormulario(prev => ({
                    ...prev,
                    amostra_possui_defeitos: e,
                    defeitos: [],
                    pontuacao_total_defeitos: 0
                  }))}
                  options={listaBool()}
                  placeholder={'Selecionar'}
                  isClearable={true}
                  isDisabled={!chamado.amostra_recebida || chamado.cancelado}
                />
              }
              {
                chamado.finalizado &&
                <div
                  className={styles.important_data}
                  style={{ color: chamado.amostra_possui_defeitos ? 'red' : 'green' }}
                >
                  {chamado.amostra_possui_defeitos ? 'Sim' : 'Não'}
                </div>
              }
            </Col>

            <div className={styles.vertical_separator} />

            <Col md={2}>
              <Form.Label>Pontuação Total Defeitos</Form.Label>
              <div
                className={styles.important_data}
                style={{ color: calcColor() }}
              >
                {chamado.finalizado ? chamado.pontuacao_total_defeitos : formulario.pontuacao_total_defeitos}
              </div>
            </Col>

            <div className={styles.vertical_separator} />

            <Col md={3}>
              <Form.Label>Resultado C.Q. Amostra</Form.Label>
              {
                chamado.finalizado ?
                  <div
                    style={{ color: calcColor() }}
                    className={styles.important_data}
                  >
                    {chamado.pontuacao_total_defeitos <= 1
                      ? 'APROVADO'
                      : chamado.pontuacao_total_defeitos <= 5
                        ? 'APROVADO COM RESTRIÇÕES'
                        : 'REPROVADO'}
                  </div>
                  :
                  <div
                    style={{ color: calcColor() }}
                    className={styles.important_data}
                  >
                    {formulario.pontuacao_total_defeitos <= 1
                      ? 'APROVADO'
                      : formulario.pontuacao_total_defeitos <= 5
                        ? 'APROVADO COM RESTRIÇÕES'
                        : 'REPROVADO'}
                  </div>
              }
            </Col>
          </Row>

          {/* RENDERIZA PARA CHAMADOS NÃO FINALIZADOS E NÃO CANCELADOS */}
          {
            !chamado.finalizado && !chamado.cancelado &&
            <>
              {renderCheckboxGrupo(listaDefeitosMedidas, 'Medidas')}
              <br />
              {renderCheckboxGrupo(listaDefeitosAcabamento, 'Acabamento')}
              <br />
              {renderCheckboxGrupo(listaDefeitosCostura, 'Costura')}

              <hr />

              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Observações Controle de Qualidade PA</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={formulario.observacoes_cq_pa || ''}
                      onChange={e => setFormulario(prev => ({ ...prev, observacoes_cq_pa: e.target.value }))}
                      placeholder='Insira suas observações aqui.'
                    />
                  </Form.Group>
                </Col>
              </Row>

              <hr />

              <Row className="mb-3">
                <Col md={12}>
                  <Form.Label>Anexar Laudo</Form.Label>
                  <Form.Control
                    type="file"
                    disabled={!chamado.amostra_recebida}
                    onChange={(e) => {
                      const file = e.target.files?.[0] || null;
                      setFormulario(prev => ({ ...prev, laudo: file }));
                    }}
                    style={{ height: '32px' }}
                  />
                </Col>
              </Row>
            </>
          }

          {/* RENDERIZA PARA CHAMADOS FINALIZADOS */}
          {
            chamado.finalizado &&
            <>
              <hr />

              <a
                style={{ fontWeight: '500' }}
                href={chamado.link_laudo}
                target="_blank"
                rel="noopener noreferrer"
              >
                {chamado.link_laudo ? 'Clique aqui para acessar o laudo' : 'Laudo não encontrado - entre em contato com seu supervisor.'}
              </a>

              <hr />

              {
                chamado.defeitos_chamado.length > 0 &&
                <>
                  <h6>DEFEITOS</h6>
                  <div className={styles.defeito_wrapper_ac}>
                    {chamado.defeitos_chamado.map(defeito => {
                      return (
                        <div className={styles.defeito} key={defeito.id_defeito}>
                          {defeito.grupo} | {defeito.descricao} | {defeito.pontos} ponto{defeito.pontos > 1 ? 's' : ''}
                        </div>
                      )
                    })}
                  </div>
                  <hr />
                </>
              }

              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Observações Controle de Qualidade PA</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={chamado.observacoes_cq_pa || ''}
                      placeholder='Nenhuma observação foi inserida pelo controle de qualidade.'
                      readOnly
                    />
                  </Form.Group>
                </Col>
              </Row>
            </>
          }
        </Modal.Body>

        <Modal.Footer>
          {
            !chamado.finalizado && !chamado.cancelado &&
            <>
              <Button
                variant="danger"
                style={{ fontWeight: '500', width: '200px' }}
                onClick={() => setShowModalCancelamento(true)}
              >
                Cancelar Chamado
              </Button>

              <Button
                variant="success"
                style={{ fontWeight: '500', width: '200px' }}
                onClick={finalizarChamado}
              >
                Finalizar Chamado
              </Button>
            </>
          }
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalCancelamento}
        onHide={() => setShowModalCancelamento(false)}
        size="md"
        backdrop="static"
        centered
        backdropClassName={styles.backdrop_z_override}
      >
        <Modal.Header closeButton style={{ fontWeight: '500' }}>Cancelar Chamado</Modal.Header>
        <Modal.Body>
          Confirma o cancelamento do chamado <span style={{ fontWeight: '500', width: '200px' }}>#{chamado.id_chamado}</span>?
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ fontWeight: '500', width: '200px', marginRight: 'auto' }}
            variant="secondary"
            onClick={() => setShowModalCancelamento(false)}
          >
            Cancelar
          </Button>
          <Button
            style={{ fontWeight: '500', width: '200px' }}
            variant="danger"
            onClick={cancelarChamado}
          >
            Cancelar Chamado
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalConfirmacao}
        onHide={() => setShowModalConfirmacao(false)}
        size="md"
        backdrop="static"
        centered
        backdropClassName={styles.backdrop_z_override}
      >
        <Modal.Header closeButton style={{ fontWeight: '500' }}>Confirmar Recebimento</Modal.Header>
        <Modal.Body>
          Confirma o recebimento da amostra do chamado <span style={{ fontWeight: '500', width: '200px' }}>#{chamado.id_chamado}</span>?
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ fontWeight: '500', width: '200px', marginRight: 'auto' }}
            variant="secondary"
            onClick={() => setShowModalConfirmacao(false)}
          >
            Cancelar
          </Button>
          <Button
            style={{ fontWeight: '500', width: '200px' }}
            variant="success"
            onClick={confirmarRecebimentoAmostra}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ChamadoQualidadePA;
